import { _ } from '_core';

import { Params } from './types';

export const validate = (params: Params) => {
  if (_.isEmpty(params.statistics_types)) return ['You need to add at least one statistic.'];
  if (_.isEmpty(params.analysis_time_series_ids)) return ['You need to add at least one time series.'];
  return [];
};
